import React, { Component } from 'react';
import ProjectModal from './ProjectModal';
import { switchBodyScroll } from '../utils/common';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ProjectThumb from './ProjectThumb';

class Project extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isModalOpened: false,
		};
	}

	openModal = () => {
		switchBodyScroll({ isBlocked: true });
		this.setState({ isModalOpened: true });
	};

	closeModal = () => {
		switchBodyScroll({ isBlocked: false });
		this.setState({ isModalOpened: false });
	};

	render() {
		let { projectName, title, thumb } = this.props;
		const { isModalOpened } = this.state;

		return (
			<React.Fragment>
				<div className='column is-12-mobile is-half-tablet is-one-third-desktop'>
					<figure
						className='image is-3by2'
						onClick={function () {
							void 0;
						}}
					>
						<ProjectThumb thumb={thumb} />
						<figcaption>
							<h1
								className='title is-size-5 is-size-4-widescreen'
								dangerouslySetInnerHTML={{ __html: title }}
							></h1>
							<button
								type='button'
								onClick={this.openModal}
								className='project__button view-project'
							>
								<span>See Project</span>
								<span className='icon'>
									<i className='angle-right'></i>
								</span>
							</button>
						</figcaption>
						<div className='overlay'></div>
					</figure>
				</div>
				<ReactCSSTransitionGroup
					transitionName='fade'
					transitionLeave={true}
					transitionEnter={false}
					transitionLeaveTimeout={400}
				>
					{isModalOpened && (
						<ProjectModal projectName={projectName} closeModal={this.closeModal} />
					)}
				</ReactCSSTransitionGroup>
			</React.Fragment>
		);
	}
}

export default Project;
